// Edit this file to include new api route variables

const   API_ROUTE       =  process.env.VUE_APP_API_ROUTE
const PCH_PROVIDER = API_ROUTE+'/pch_provider'
// GModule
const GET_MENU_USER = API_ROUTE + '/get_menu_module_user'
const GET_LOGIN_MODULE_DATA = API_ROUTE + '/get_login_module'
// Auth token
const GET_LOGIN_TOKEN = API_ROUTE + '/auth/get_login_token'
const LOGOUT_REQUEST = API_ROUTE + '/auth/logout'
const PCH_PURCHASE_ORDER = API_ROUTE + '/pch_purchase_order'
const WH_PRODUCT = API_ROUTE + '/wh_product'
export default {
    PCH_PROVIDER,
    GET_LOGIN_MODULE_DATA,
    GET_LOGIN_TOKEN,
    GET_MENU_USER,
    LOGOUT_REQUEST,
    PCH_PURCHASE_ORDER,
    WH_PRODUCT,
}